export const worksheetFormStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
};

export const worksheetChecklistWrapperStyles = {
  marginTop: '16px',
  paddingTop: '16px',
  borderTop: ({ palette }) => `1px solid ${palette.divider}`,
};

export const worksheetCalculatedValuesWrapperStyles = {
  marginTop: '16px',
  paddingTop: '16px',
  borderTop: ({ palette }) => `1px solid ${palette.divider}`,
};

export const worksheetCalculatedValueRowStyles = {
  display: 'flex',
  justifyContent: 'space-between',
  gap: '16px',
  padding: '4px 0',
};

export const worksheetLoanFactsAccordionStyles = {
  padding: '8px 12px',
  border: ({ palette }) => `1px solid ${palette.divider}`,
  boxShadow: 'none',
};

export const worksheetLoanFactsSectionStyles = {
  marginTop: '12px',
};

// The drawer body scrolls with 24px of top padding; pinning the bar over that padding keeps the
// questions from showing through above it while scrolling.
export const worksheetStatusBarStyles = {
  position: 'sticky',
  top: '-24px',
  zIndex: 2,
  marginTop: '-24px',
  paddingTop: '24px',
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: '8px 16px',
  paddingBottom: '12px',
  marginBottom: '8px',
  backgroundColor: ({ palette }) => palette.background.paper,
  borderBottom: ({ palette }) => `1px solid ${palette.divider}`,
};

export const worksheetStatusBarChipsStyles = {
  display: 'flex',
  flexWrap: 'wrap',
  gap: '8px',
};

// Wide drawers show the loan facts beside the questions (kept in view while answering);
// narrow ones stack them above.
export const getWorksheetBodyStyles = ({ hasLoanFacts }) => ({
  display: 'grid',
  gridTemplateColumns: hasLoanFacts
    ? { xs: 'minmax(0, 1fr)', lg: '320px minmax(0, 1fr)' }
    : 'minmax(0, 1fr)',
  columnGap: '24px',
  alignItems: 'start',
});

export const worksheetLoanFactsColumnStyles = {
  position: { lg: 'sticky' },
  top: { lg: '48px' },
  maxHeight: { lg: 'calc(100vh - 240px)' },
  overflowY: { lg: 'auto' },
};

export const worksheetLoanFactsRowsStyles = {
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fill, minmax(140px, 1fr))',
  gap: '8px 16px',
  marginTop: '4px',
};

export const worksheetLoanFactsRowStyles = {
  display: 'flex',
  flexDirection: 'column',
  minWidth: 0,
  overflowWrap: 'anywhere',
};
